import React from 'react';
import styles from '@/creditflowresearch/ui/common/components/organisms/Filters/filters.module.scss';

interface IProps {
  className?: string,
  isExpandable?: boolean,
  itemsCount?: number,
  selectedItemsCount?: number,
  children: React.ReactNode,
  dataTest?: string,
}

function FilterItem(props: IProps) {
  const {
    className = styles.filterItem,
    itemsCount = 0,
    selectedItemsCount = 0,
    children,
    isExpandable = true,
    dataTest = 'filterItem',
  } = props;

  return (
    <div className={ className } data-test={ dataTest }>
      <div className={ styles.filterItemCheckbox } data-test="filterItemCheckbox">
        { children }
      </div>
      { itemsCount > 0 && (
        <div className={ styles.filterItemCount }>
          {
            selectedItemsCount > 0
              ? (<><span className={ styles.filterItemCountSelected }>{ selectedItemsCount }</span> / { itemsCount }</>)
              : (<>{ itemsCount }</>)
          }
        </div>
      ) }
      { isExpandable && (
        <div className={ styles.filterItemExpand } />
      ) }
    </div>
  );
}

export default React.memo(FilterItem);
